<template>
  <PropertyDetailsCard id="prop-parking-card">
    <template #title>Parking</template>
    <template #action>
      <PropertyDetailsCardEditButton v-if="hasInfo" @click="showModal" />
    </template>

    <PropertyParkingInfo v-if="hasInfo" :property="property" />
    <PropertyDetailsCardPlaceholder
      v-else
      title="You haven't added parking details yet"
      subtitle="Specify parking availability and any associated costs"
      button-text="Add parking"
      @button-clicked="showModal"
    />
    <PropertyParkingModal ref="parkingModalRef" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

import { usePropertyStore } from '@tallo/investor/property';
import {
  PropertyDetailsCard,
  PropertyDetailsCardEditButton,
  PropertyDetailsCardPlaceholder,
  PropertyParkingInfo,
} from '@tallo/property';

import PropertyParkingModal from './property-parking-modal.vue';

const { property } = usePropertyStore();
const parkingModalRef = ref<InstanceType<typeof PropertyParkingModal>>();
const hasInfo = computed(() => Boolean(property?.parking));

function showModal() {
  parkingModalRef?.value?.modalRef?.show();
}
</script>
